import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const FailedToFetchUsersAlert = ({ handleFetchUsersFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleFetchUsersFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleFetchUsersFailed}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.bulkImportFetchUsersFailed)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default FailedToFetchUsersAlert;
